"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const ScopeBarItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/ScopeBarItem.vue"));
let ScopeBar = class ScopeBar extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.activeScope = 'block';
        this.scopes = [
            {
                hook: 'area',
                label: 'Area',
                icon: 'Square',
            },
            /*         {
                        hook: 'homogenous zones',
                        label: 'Homogenous Zones',
                        icon: 'FlipVertical',
                    }, */
            {
                hook: 'block',
                label: 'Block',
                icon: 'LayoutDashboard',
            },
            /* {
                hook: 'sample',
                label: 'Sample',
                icon: 'Circle',
            }, */
            {
                hook: 'hd',
                label: 'High Resolution',
                icon: 'Star',
            },
        ];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    changeScope(hook) {
        this.activeScope = hook;
        this.$emit('changeScope', hook);
    }
    resetCurrentScope() {
        if (this.activeScope !== this.value)
            this.activeScope = this.value;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'horizontal' })
], ScopeBar.prototype, "orientation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'onlyactive' })
], ScopeBar.prototype, "labelDeploy", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ScopeBar.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'area' })
], ScopeBar.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], ScopeBar.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], ScopeBar.prototype, "allDisabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value')
], ScopeBar.prototype, "resetCurrentScope", null);
ScopeBar = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ScopeBarItem: ScopeBarItem_vue_1.default,
            Square: lucide_vue_next_1.Square,
            LayoutDashboard: lucide_vue_next_1.LayoutDashboard,
            Circle: lucide_vue_next_1.Circle,
            Star: lucide_vue_next_1.Star,
            FlipVertical: lucide_vue_next_1.FlipVertical,
        },
    })
], ScopeBar);
exports.default = ScopeBar;
